<i18n>
{
  "fr": {
    "titleBuyer": "INFORMATIONS ACHETEUR",
    "registration": "Matricule",
    "lastName": "Nom",
    "firstName": "Prénom",
    "email": "E-mail",
    "phoneNumber": "Tél. portable",
    "commentTitle": "Commentaire",
    "placeholder": "N'hésitez pas à préciser votre demande par toute information vous paraissant utile",
    "required": "Champs requis"
  },
  "en": {
    "titleBuyer": "BUYER INFORMATION",
    "registration": "Registration number",
    "lastName": "Last Name",
    "firstName": "First Name",
    "email": "E-mail",
    "phoneNumber": "Mobile phone",
    "commentTitle": "Comment",
    "placeholder": "Feel free to specify your request by providing any information you deem useful",
    "required": "Required"
  }
}
</i18n>

<template>
  <v-container>
    <h2
      class="title-container"
    >
      {{ $t('titleBuyer') }}
    </h2>
    <v-row>
      <v-col
        cols="10"
        md="3"
      >
        <label
          class="title-input"
          for="matriculeId"
        >
          {{ $t('registration') }}
        </label>
        <v-text-field
          id="matriculeId"
          v-model="matricule"
          color="primary"
          background-color="primaryLight"
          solo
          flat
          required
          hide-details
          :rules="[value => !!value || 'Champs requis']"
        />
        <span
          v-if="!matricule && this.formNotValidate"
          class="error-message"
        >
          {{ $t('required') }}
        </span>
      </v-col>
      <v-col
        cols="10"
        md="3"
      >
        <label
          class="title-input"
          for="acheteurNomId"
        >
          {{ $t('lastName') }}
        </label>
        <v-text-field
          id="acheteurNomId"
          v-model="acheteurNom"
          color="primary"
          background-color="primaryLight"
          solo
          flat
          required
          hide-details
          :rules="[value => !!value || 'Champs requis']"
        />
        <span
          v-if="!acheteurNom && this.formNotValidate"
          class="error-message"
        >
          {{ $t('required') }}
        </span>
      </v-col>
      <v-col
        cols="10"
        md="3"
      >
        <label
          class="title-input"
          for="acheteurPrenomId"
        >
          {{ $t('firstName') }}
        </label>
        <v-text-field
          id="acheteurPrenomId"
          v-model="acheteurPrenom"
          color="primary"
          background-color="primaryLight"
          solo
          flat
          required
          hide-details
          :rules="[value => !!value || 'Champs requis']"
        />
        <span
          v-if="!acheteurPrenom && this.formNotValidate"
          class="error-message"
        >
          {{ $t('required') }}
        </span>
      </v-col>
      <v-col
        cols="10"
        md="3"
      >
        <label
          class="title-input"
          for="acheteurEmailId"
        >
          {{ $t('email') }}
        </label>
        <v-text-field
          id="acheteurEmailId"
          v-model="acheteurEmail"
          color="primary"
          background-color="primaryLight"
          solo
          flat
          required
          hide-details
          type="email"
          :rules="[value => !!value || 'Champs requis']"
        />
        <span
          v-if="!acheteurEmail && this.formNotValidate"
          class="error-message"
        >
          {{ $t('required') }}
        </span>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="10"
        md="3"
      >
        <label
          class="title-input"
          for="telephonePortableId"
        >
          {{ $t('phoneNumber') }}
        </label>
        <v-text-field
          id="telephonePortableId"
          v-model="telephonePortable"
          color="primary"
          background-color="primaryLight"
          solo
          flat
          required
          hide-details
          :rules="[value => !!value || 'Champs requis']"
        />
        <span
          v-if="!telephonePortable && this.formNotValidate"
          class="error-message"
        >
          {{ $t('required') }}
        </span>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="40"
      >
        <label
          class="title-input"
          for="commentaireId"
        >
          {{ $t('commentTitle') }}
        </label>
        <v-textarea
          id="commentaireId"
          v-model="commentaire"
          color="primary"
          background-color="primaryLight"
          solo
          flat
          :placeholder="$t('placeholder')"
          hide-details
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data: () => ({
    matricule: '',
    acheteurNom: '',
    acheteurPrenom: '',
    acheteurEmail: '',
    telephonePortable: '',
    commentaire: ''
  }),
  computed: {
    ...mapGetters({
      customer: 'general/getCustomer'
    })
  },
  props: {
    formNotValidate: {
      type: Boolean,
      default: false
    }
  },
  mounted () {
    this.matricule = this.customer.registration_number
    this.acheteurNom = this.customer.last_name
    this.acheteurPrenom = this.customer.first_name
    this.acheteurEmail = this.customer.email
    this.telephonePortable = this.customer.phone_mobile
  },
  methods: {
    validateBuyerForm () {
      return {
        registrationNumber: this.matricule,
        buyerLastName: this.acheteurNom,
        buyerFirstName: this.acheteurPrenom,
        buyerEmail: this.acheteurEmail,
        buyerPhoneNumber: this.telephonePortable,
        buyerComment: this.commentaire
      }
    }
  }
}
</script>

<style scoped>
.error-message {
  color: red;
  font-size: 14px;
  font-style: italic;
}

.title-container {
  margin-bottom: 17px;
  font-weight: 800;
  color: #006fb9;
  margin-top: 20px;
}

.title-input {
  color: #006fb9;
  font-size: 18px;
  font-weight: 550;
  opacity: 0.8;
}

</style>
